import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'put',
                url: urls.PUT_EXCHANGE_RATES
            });
            window.location.replace('/settings/exchange-rates');
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateExchangeRates as SetPostUpdateExchangeRates
}